export const GET_ASSET_CATEGORIES = "GET_ASSET_CATEGORIES";
export const UPDATE_ASSET_CATEGORY = "UPDATE_ASSET_CATEGORY";
export const ADD_ASSET_CATEGORY = "ADD_ASSET_CATEGORY";
export const DELETE_ASSET_CATEGORIES = "DELETE_ASSET_CATEGORIES";
